import { FeeEarner, FeeEarnerCascaderValue } from "../data-types";

export const cascaderValueFromFeeEarner = (feeEarner: FeeEarner): FeeEarnerCascaderValue => {
  return feeEarner?.feeEarnerLevel ? [feeEarner.feeEarnerLevel.id, feeEarner.id] : [];
};

export const feeEarnerIdFromCascaderValue = (
  cascaderData: FeeEarnerCascaderValue
): FeeEarner["id"] | null => {
  const parsedCascaderData: number[] = (cascaderData as any[]).map((value: string | number) => {
    return typeof value === "number" ? value : parseInt(value);
  });

  if (parsedCascaderData.length > 1) {
    return parsedCascaderData[1];
  }

  return null;
};
